import { render, staticRenderFns } from "./advertisement.vue?vue&type=template&id=79de157e&scoped=true&"
import script from "./advertisement.vue?vue&type=script&lang=js&"
export * from "./advertisement.vue?vue&type=script&lang=js&"
import style0 from "./advertisement.vue?vue&type=style&index=0&id=79de157e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79de157e",
  null
  
)

export default component.exports